/** @format */

import { Container } from './section3.style';

//images
import Team from '../../Assets/Team_photo.png';

import { CustomArrowProps } from 'react-slick';
import LiveEdithTextHighLighter from '../../../../liveEditHighlighterstyles/liveEdithTextHighLighter.component';
import LiveEditImageHighLighter from '../../../../liveEditHighlighterstyles/liveEditImageHighLighter.component';

import CityCardContainer from '../../../utilComponent/citycards_container/CityCards.utilComponent';
import { useState } from 'react';

import FeaturePropertySlider from '../../../utilComponent/FeaturePropertySlider/FeaturePropertySlider.utilComponent';

// Keyframes for animation
const animationStyles = {
  '@keyframes hoverAnimation': {
    '0%': { transform: 'scale(1)', color: 'black' },
    '50%': { transform: 'scale(1.1)', color: 'blue' },
    '100%': { transform: 'scale(1)', color: 'black' },
  },
  hoverEffect: {
    animation: 'hoverAnimation 0.5s ease-in-out',
  },
};

type SectionProps = {
  sec3: {
    text: string;
    description: string;
    subtext: string;
    color: string;
    cards: [Record<string, string>];
    visible: boolean;
    image: string;
  };
  sec4: Record<string, string>;
  sec5: SectionProps4_5;
  sec6: SectionProps4_5;
};

type SectionProps4_5 = {
  text: string;
  description: string;
  color: string;

  cards: [Record<string, string>];
  action: Record<string, string>;
  image?: string;
  visible: boolean;
};

type SectionDataProp = {
  data?: SectionProps;
};

export default function Section3({ data }: SectionDataProp) {
  // const { state } = useLiveEditorHighLighter()
  // const SliderRef = useRef(null)
  // useEffect(() => {
  //   const SlideNumber = state.type.split('-')
  //   if (SlideNumber.length > 1) {
  //     if (SliderRef.current) {
  //       SliderRef?.current?.slickGoTo(Number(SlideNumber[1]))
  //     }
  //   }
  // }, [state.type])
  const CustomArrowsPrev = (props: CustomArrowProps) => {
    const { onClick } = props;
    return (
      <div
        className="custom_arrows_prev"
        onClick={onClick}>
        <svg
          width="50"
          height="50"
          viewBox="0 0 50 50"
          fill="none"
          xmlns="http://www.w3.org/2000/svg">
          <path
            d="M25.1367 0.5C27.3789 0.5 29.5299 0.791667 31.5898 1.375C33.6497 1.95833 35.5911 2.77865 37.4141 3.83594C39.237 4.89323 40.8776 6.16016 42.3359 7.63672C43.7943 9.11328 45.0703 10.763 46.1641 12.5859C47.2578 14.4089 48.0781 16.3411 48.625 18.3828C49.1719 20.4245 49.4635 22.5846 49.5 24.8633C49.5 27.1055 49.2083 29.2565 48.625 31.3164C48.0417 33.3763 47.2214 35.3177 46.1641 37.1406C45.1068 38.9635 43.8398 40.6042 42.3633 42.0625C40.8867 43.5208 39.237 44.7969 37.4141 45.8906C35.5911 46.9844 33.6589 47.8047 31.6172 48.3516C29.5755 48.8984 27.4154 49.1901 25.1367 49.2266C22.8945 49.2266 20.7435 48.9349 18.6836 48.3516C16.6237 47.7682 14.6823 46.9479 12.8594 45.8906C11.0365 44.8333 9.39583 43.5664 7.9375 42.0898C6.47917 40.6133 5.20312 38.9635 4.10938 37.1406C3.01562 35.3177 2.19531 33.3854 1.64844 31.3438C1.10156 29.3021 0.809896 27.1419 0.773438 24.8633C0.773438 22.6211 1.0651 20.4701 1.64844 18.4102C2.23177 16.3503 3.05208 14.4089 4.10938 12.5859C5.16667 10.763 6.43359 9.1224 7.91016 7.66406C9.38672 6.20573 11.0365 4.92969 12.8594 3.83594C14.6823 2.74219 16.6146 1.92188 18.6562 1.375C20.6979 0.828125 22.8581 0.536458 25.1367 0.5ZM25.1367 45.7266C27.0508 45.7266 28.8919 45.4805 30.6602 44.9883C32.4284 44.4961 34.0964 43.7943 35.6641 42.8828C37.2318 41.9714 38.6354 40.8867 39.875 39.6289C41.1146 38.3711 42.1992 36.9583 43.1289 35.3906C44.0586 33.8229 44.7604 32.1641 45.2344 30.4141C45.7083 28.6641 45.9635 26.8138 46 24.8633C46 22.9492 45.7539 21.1081 45.2617 19.3398C44.7695 17.5716 44.0677 15.9128 43.1562 14.3633C42.2448 12.8138 41.151 11.401 39.875 10.125C38.599 8.84896 37.1953 7.76432 35.6641 6.87109C34.1328 5.97786 32.474 5.27604 30.6875 4.76562C28.901 4.25521 27.0508 4 25.1367 4C23.2227 4 21.3815 4.24609 19.6133 4.73828C17.8451 5.23047 16.1771 5.93229 14.6094 6.84375C13.0417 7.75521 11.638 8.83984 10.3984 10.0977C9.15885 11.3555 8.07422 12.7682 7.14453 14.3359C6.21484 15.9036 5.51302 17.5625 5.03906 19.3125C4.5651 21.0625 4.3099 22.9128 4.27344 24.8633C4.27344 26.7773 4.51953 28.6185 5.01172 30.3867C5.50391 32.1549 6.20573 33.8229 7.11719 35.3906C8.02865 36.9583 9.11328 38.362 10.3711 39.6016C11.6289 40.8411 13.0417 41.9258 14.6094 42.8555C16.1771 43.7852 17.8359 44.487 19.5859 44.9609C21.3359 45.4349 23.1862 45.6901 25.1367 45.7266ZM30.6055 14.8555L20.4883 25L30.6055 35.1445L28.1445 37.6055L15.5117 25L28.1445 12.3945L30.6055 14.8555Z"
            fill="white"
          />
        </svg>
      </div>
    );
  };

  const CustomArrowsNext = (props: CustomArrowProps) => {
    const { onClick } = props;
    return (
      <div
        className="custom_arrows_next"
        onClick={onClick}>
        <svg
          width="50"
          height="50"
          viewBox="0 0 50 50"
          fill="none"
          xmlns="http://www.w3.org/2000/svg">
          <path
            d="M25.1367 49.2266C22.8945 49.2266 20.7435 48.9349 18.6836 48.3516C16.6237 47.7682 14.6823 46.9479 12.8594 45.8906C11.0365 44.8333 9.39583 43.5664 7.9375 42.0898C6.47917 40.6133 5.20312 38.9635 4.10938 37.1406C3.01562 35.3177 2.19531 33.3854 1.64844 31.3437C1.10156 29.3021 0.809895 27.1419 0.773438 24.8633C0.773438 22.6211 1.06511 20.4701 1.64844 18.4102C2.23177 16.3503 3.05208 14.4089 4.10938 12.5859C5.16667 10.763 6.43359 9.12239 7.91016 7.66406C9.38672 6.20573 11.0365 4.92969 12.8594 3.83594C14.6823 2.74219 16.6146 1.92187 18.6563 1.375C20.6979 0.828125 22.8581 0.536457 25.1367 0.5C27.3789 0.5 29.5299 0.791668 31.5898 1.375C33.6497 1.95833 35.5911 2.77864 37.4141 3.83594C39.237 4.89323 40.8776 6.16016 42.3359 7.63672C43.7943 9.11328 45.0703 10.763 46.1641 12.5859C47.2578 14.4089 48.0781 16.3411 48.625 18.3828C49.1719 20.4245 49.4635 22.5846 49.5 24.8633C49.5 27.1055 49.2083 29.2565 48.625 31.3164C48.0417 33.3763 47.2214 35.3177 46.1641 37.1406C45.1068 38.9635 43.8398 40.6042 42.3633 42.0625C40.8867 43.5208 39.237 44.7969 37.4141 45.8906C35.5911 46.9844 33.6589 47.8047 31.6172 48.3516C29.5755 48.8984 27.4154 49.1901 25.1367 49.2266ZM25.1367 4C23.2227 4 21.3815 4.24609 19.6133 4.73828C17.8451 5.23047 16.1771 5.93229 14.6094 6.84375C13.0417 7.75521 11.638 8.83984 10.3984 10.0977C9.15886 11.3555 8.07422 12.7682 7.14453 14.3359C6.21484 15.9036 5.51302 17.5625 5.03906 19.3125C4.56511 21.0625 4.30989 22.9128 4.27344 24.8633C4.27344 26.7773 4.51953 28.6185 5.01172 30.3867C5.50391 32.1549 6.20573 33.8138 7.11719 35.3633C8.02864 36.9128 9.12239 38.3255 10.3984 39.6016C11.6745 40.8776 13.0781 41.9622 14.6094 42.8555C16.1406 43.7487 17.7995 44.4505 19.5859 44.9609C21.3724 45.4714 23.2227 45.7266 25.1367 45.7266C27.0508 45.7266 28.8919 45.4805 30.6602 44.9883C32.4284 44.4961 34.0964 43.7943 35.6641 42.8828C37.2318 41.9714 38.6354 40.8867 39.875 39.6289C41.1146 38.3711 42.1992 36.9583 43.1289 35.3906C44.0586 33.8229 44.7604 32.1641 45.2344 30.4141C45.7083 28.6641 45.9635 26.8138 46 24.8633C46 22.9492 45.7539 21.1081 45.2617 19.3398C44.7695 17.5716 44.0677 15.9036 43.1563 14.3359C42.2448 12.7682 41.1602 11.3646 39.9023 10.125C38.6445 8.88542 37.2318 7.80078 35.6641 6.87109C34.0964 5.94141 32.4375 5.23958 30.6875 4.76562C28.9375 4.29167 27.0872 4.03646 25.1367 4ZM19.668 34.8711L29.7852 24.7266L19.668 14.582L22.1289 12.1211L34.7617 24.7266L22.1289 37.332L19.668 34.8711Z"
            fill="white"
          />
        </svg>
      </div>
    );
  };

  return (
    <Container sec5color={data.sec5.color}>
      {data.sec3.visible && (
        <div
          id="sec3"
          className="sec2bg"
          style={{
            backgroundImage: `url(${data?.sec3?.image?.length ? `/public/${data?.sec3?.image}` : Team
              })`,
          }}>
          <LiveEdithTextHighLighter
            section="sec3"
            type="text">
            <div
              className="hoverEffect"
              style={{ color: '#fff' ,textAlign:"center",fontFamily:"Tenor Sans, sans-serif",fontWeight:"bold"}} dangerouslySetInnerHTML={{ __html: data.sec3.text }}>
            </div>
          </LiveEdithTextHighLighter>
          <LiveEdithTextHighLighter
            section="sec3"
            type="description">
            <div
              className="sub_heading"
              style={{ color: '#fff',textAlign:"center"}} dangerouslySetInnerHTML={{ __html: data.sec3.description }}>
            </div>
          </LiveEdithTextHighLighter>
          <LiveEdithTextHighLighter
            section="sec3"
            type="year">
            <p
              className="year"
              style={{ color: '#fff' }}>
              {data.sec3.subtext}
            </p>
          </LiveEdithTextHighLighter>

          <div className="information">
            {data.sec3.cards.map((data, index) => (
              <div
                className="CardInfo"
                key={data.text}>
                <LiveEdithTextHighLighter
                  section="sec3"
                  type={`index${index}text`}>
                  <h1>{data.text}</h1>
                </LiveEdithTextHighLighter>
                <LiveEdithTextHighLighter
                  section="sec3"
                  type={`cards${index}description`}>
                  <div dangerouslySetInnerHTML={{ __html: data.description }} style={{ textAlign: 'center' }} ></div>
                </LiveEdithTextHighLighter>
              </div>
            ))}
          </div>
        </div>
      )}
      {data.sec4.visible && (
        <LiveEditImageHighLighter
          section="sec4"
          type="image">
          <div
            className="background_image_text"
            id="sec4">
            <p>
              <LiveEdithTextHighLighter
                section="sec4"
                type="text">
                {data.sec4.text}
              </LiveEdithTextHighLighter>
            </p>
            <img
              src={`/public/${data.sec4.image}`}
              alt="BackgroundImage"
            />
          </div>
        </LiveEditImageHighLighter>
      )}
      {/* <FeaturePropertySlider /> */}
      {data.sec5.visible && (
        <div
          className="cities_container"
          id="sec5">
          {/* <SliderContainer>
          <Slider
            {...CitiesSetting}
            className="slider" ref={SliderRef}>
            {data.sec4.cards.map((data, index) => (

              <div
                className="city_card"
                key={data.text}>

                <City to={`../idxlisting/?city=${data.text}`}>
                  <p className="city_name">
                    <LiveEdithTextHighLighter section='sec4' type={`text-${index}`}>
                      {data.text}
                    </LiveEdithTextHighLighter>
                  </p>
                  <div className='city_image'>
                    <LiveEditImageHighLighter key={data.text} section='sec4' type={`image${index}`}>
                      <img
                        src={`/public/${data.image}`}
                        alt="cityImages"
                      />
                    </LiveEditImageHighLighter>
                  </div>
                </City>

              </div>

            ))}
          </Slider>
        </SliderContainer> */}
          <CityCardContainer
            data={data.sec5.cards}
            CustomArrowsNext={CustomArrowsNext}
            CustomArrowsPrev={CustomArrowsPrev}
            type={'sec5'}
          />
          <div className="quote">
            <p>
              {' '}
              <LiveEdithTextHighLighter
                section="sec5"
                type="quote">
                {data.sec5.text}
              </LiveEdithTextHighLighter>
            </p>
            <div className="svg_wrapper">
              <svg
                viewBox="0 0 353 243"
                fill="none"
                xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M275.781 154.625C260.509 154.625 245.579 150.096 232.881 141.611C220.182 133.126 210.285 121.067 204.44 106.957C198.596 92.8467 197.067 77.3206 200.046 62.3417C203.026 47.3627 210.38 33.6036 221.179 22.8044C231.979 12.0052 245.738 4.65077 260.717 1.67127C275.696 -1.30823 291.222 0.220958 305.332 6.06546C319.441 11.91 331.501 21.8073 339.986 34.5059C348.471 47.2044 353 62.1339 353 77.4063L353.353 88.4375C353.353 108.719 349.358 128.801 341.597 147.538C333.836 166.275 322.46 183.3 308.119 197.641C293.779 211.982 276.753 223.358 258.016 231.119C239.279 238.88 219.197 242.875 198.916 242.875V198.75C213.408 198.789 227.765 195.954 241.156 190.41C254.546 184.866 266.705 176.723 276.929 166.451C280.902 162.484 284.568 158.221 287.894 153.698C283.887 154.328 279.837 154.645 275.781 154.647V154.625ZM77.2188 154.625C61.9464 154.625 47.0169 150.096 34.3183 141.611C21.6198 133.126 11.7225 121.067 5.87796 106.957C0.0334582 92.8467 -1.49573 77.3206 1.48377 62.3417C4.46327 47.3627 11.8176 33.6036 22.6169 22.8044C33.4161 12.0052 47.1752 4.65077 62.1542 1.67127C77.1331 -1.30823 92.6592 0.220958 106.769 6.06546C120.879 11.91 132.939 21.8073 141.424 34.5059C149.909 47.2044 154.438 62.1339 154.438 77.4063L154.791 88.4375C154.791 129.397 138.519 168.679 109.557 197.641C80.5942 226.604 41.3124 242.875 0.353035 242.875V198.75C14.8458 198.789 29.2026 195.954 42.5932 190.41C55.9837 184.866 68.1423 176.723 78.366 166.451C82.3396 162.484 86.0052 158.221 89.3311 153.698C85.3243 154.328 81.2747 154.645 77.2188 154.647V154.625Z"
                  fill="white"
                  fill-opacity="0.5"
                />
              </svg>
            </div>
          </div>
        </div>
      )}
      {data.sec6.visible && (
        <LiveEditImageHighLighter
          section="sec6"
          type="image">
          <div
            className="parallax-container"
            id="sec6">
            {/* Parallax Background */}
            <div
              className="parallax-image"
              style={{
                backgroundImage: `url(${data?.sec6?.image?.length
                  ? `/public/${data?.sec6?.image}`
                  : Team
                  })`,
              }}></div>

            {/* Parallax Content */}
            <div className="team_content parallax-content">
              <h1 style={{fontFamily:"Tenor Sans, sans-serif",fontWeight:"bold"}}>
                <LiveEdithTextHighLighter
                  section="sec6"
                  type="text">
                  {data.sec6.text}
                </LiveEdithTextHighLighter>
              </h1>
              <LiveEdithTextHighLighter
                section="sec6"
                type="description">
                <div dangerouslySetInnerHTML={{ __html: data.sec6.description }}></div>
              </LiveEdithTextHighLighter>
              <button>{data.sec6.action.text}</button>
            </div>
          </div>
        </LiveEditImageHighLighter>
      )}
    </Container>
  );
}
